import React from 'react';
import {
  Box,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: (isCancel?: boolean) => void;
  plate: string;
  date: string;
  id: string;
}

export const ConfirmModal = ({
  isOpen,
  onClose,
  plate,
  date,
  id,
}: ConfirmModalProps) => {
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent w="90%">
        <ModalCloseButton color="black" />
        <ModalHeader>
          <Text fontSize="20px" color="black">
            Solicitação de agendamento registrada com sucesso!
          </Text>
          <Text fontSize="14px" color="black" mt="18px">
            Em breve enviaremos a confirmação de agendamento e dados da oficina
            que irá atendê-lo
          </Text>
        </ModalHeader>
        <ModalBody mb="24px">
          <Flex flexDir={{ base: 'column', sm: 'row' }} gap="18px">
            <Box>
              <Text color="text.300" fontSize="14px" as="label">
                Placa do Veículo
              </Text>
              <Input
                readOnly
                bg="grey.200"
                border="1px solid"
                borderColor="grey.600"
                value={plate}
              />
            </Box>
            <Box>
              <Text color="text.300" fontSize="14px" as="label">
                Data sugerida
              </Text>
              <Input
                readOnly
                bg="grey.200"
                border="1px solid"
                borderColor="grey.600"
                value={date?.split('-').reverse().join('/')}
              />
            </Box>

            <Box>
              <Text color="text.300" fontSize="14px" as="label">
                N.º de atendimento
              </Text>
              <Input
                readOnly
                bg="grey.200"
                border="1px solid"
                borderColor="grey.600"
                value={id}
              />
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
